export class PaginationInformation {

  constructor(public scopeId: string, public previousElementCount: number, public elementsFollow: boolean, public totalElementCount?: number) {
  }
}
